export default {
    BASE_URL: '/crm/company',
    api: [
        {
            name: 'detail',
            desc: '获取企业细腻',
            method: 'GET',
            path: ''
        },
        {
            name: 'update',
            desc: '更新企业信息',
            method: 'PUT',
            path: 'update'
        },
        {
            name: 'submit',
            desc: '提交审核',
            method: 'PUT',
            path: 'submit'
        },
        {
            name: 'save',
            desc: '保存企业信息',
            method: 'PUT',
            path: 'save'
        },
        {
            name: 'subcontractList',
            desc: '劳务分包列表',
            method: 'GET',
            path: '/subpackage/list'
        },
        {
            name: 'subcontractCompanyList',
            desc: '劳务分包承包商列表（查询）',
            method: 'GET',
            path: '/subpackage/search'
        },
        {
            name: 'insertSubconrtact',
            desc: '新增劳务分包',
            method: 'POST',
            path: '/subpackage/add'
        },
        {
            name: 'cancelSubcontract',
            desc: '解除',
            method: 'PUT',
            path: '/subpackage/relieve'
        },
        {
            name: 'deleteSubcontractFile',
            desc: '删除分包合同文件',
            method: 'DELETE',
            path: '/subpackage/del'
        }
    ]
}



// WEBPACK FOOTER //
// ./src/api/company/index.js